module.exports = __webpack_public_path__ + "img/mapicon.37b1a769.png";